module.exports = __webpack_public_path__ + "assets/address-icon.2fe0429c.svg";